import { useState } from "react";
import "./SettingPassword.css";

const SettingPassword = () => {
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [twoStepAuth, setTwoStepAuth] = useState(false);

  return (
    <div className="settingPassword">
      <form className="settingPassword__formContainer">
        <div className="settingPassword__profileInputSections flex-row">
          <div className="settingPassword__profileInputContainer flex-column">
            <label htmlFor="current-password">Current Password</label>
            <input
              type="password"
              id="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your old password"
            />
          </div>
          <div className="settingPassword__profileInputContainer flex-column">
            <label htmlFor="new-password">New Password</label>
            <input
              type="password"
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter your new password"
            />
          </div>
        </div>
        <div className="settingPassword__profileInputSections flex-row">
          <div className="settingPassword__profileInputContainer flex-column">
            <label htmlFor="confirm-new-password">Confirm New Password</label>
            <input
              type="password"
              id="confirm-new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your new password"
            />
          </div>
          <div className="settingPassword__profileInputContainer flex-column">
            <label htmlFor="last-name">Password Requirements:</label>
            <ul className="settingPassword__requirements">
              <li>At least 8 characters (and up to 100 characters)</li>
              <li>Mix of numbers and letters</li>
              <li>
                Inclusion of at least one special charachter, e.g.,! @ # ?
              </li>
            </ul>
          </div>
        </div>
        <div className="settingPassword__twoStep flex-row">
          <div className="settingPassword__twoStepDesc">
            <div className="settingPassword__twoStepHeader">
              <h3>Two Factor Authentication</h3>
              <span>Recommended</span>
            </div>
            <p>
              To help keep your account secure, we'll ask you to submit a code
              when using a new device to log in. We'll send the code via SMS,
              email, or Fiverr notification.
            </p>
          </div>
          <div
            className={`settingPassword__dropdownToggle ${
              twoStepAuth && "active"
            }`}
            onClick={() => setTwoStepAuth((twoStepAuth) => !twoStepAuth)}
          >
            <input
              type="checkbox"
              checked={twoStepAuth}
              onChange={() => setTwoStepAuth((twoStepAuth) => !twoStepAuth)}
            />
            <div className="settingPassword__dropdownToggleIcon item-center rounded"></div>
          </div>
        </div>
        <button className={`settingPassword__btnUpdate btn ${password !== "" && newPassword !== "" && confirmPassword !== "" && "primary"}`}>
          Update
        </button>
      </form>
    </div>
  );
};

export default SettingPassword;
